import React from 'react';
import axios from 'axios';
import ExtraSearchForm from 'containers/extra/extraSearchForm';
import ExtraEdit from 'containers/extra/extraEdit';
import { Layout, Typography, Spin, Table, Avatar, Button, Space, Row, Col, message, Divider } from 'antd';
import { Link } from 'react-router-dom';
import {
    PlusOutlined,
    EyeOutlined,
} from '@ant-design/icons';

const { Content } = Layout;
const { Title } = Typography;

class ExtraList extends React.Component {
    constructor(props: any) {
        super(props);
        this.getMembers();
    }

    state = {
        memberData: [],
        userInfo: [],
        loading: true,
        total: 0,
        editorVisible: false,
        editorTitle: "Modal Title",
        dataId: 0,
    };

    getMembers = () => {
        axios.get('https://www.fastmock.site/mock/9973669a2a13cbb70690fdf6f1880e97/admin/extra/list', {
            params: {}
        })
            .then((res) => {
                console.log('res', res.data.data.list)
                this.setState({
                    memberData: res.data.data.list,
                    total: res.data.data.total,
                    loading: false
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    columns = [
        {
            title: 'ID',
            dataIndex: 'id',
        },
        {
            title: 'SKU编码',
            dataIndex: 'skuId',
        },
        {
            title: '资源名称',
            dataIndex: 'name',
        },
        {
            title: '资源类别',
            dataIndex: 'category',
        },
        {
            title: '说明',
            dataIndex: 'intro',
        },
        {
            title: '价格',
            dataIndex: 'price',
        },
        {
            title: '出发城市',
            dataIndex: 'departureCity',
        },
        {
            title: '资源所用城市',
            dataIndex: 'currentCity',
        },
        {
            title: '更新时间',
            dataIndex: 'updateTime',
        },
        {
            title: '操作',
            dataIndex: 'userId',
            render: (text: React.ReactNode) => <Button shape="round" key={`a-${text}`}><EyeOutlined />查看</Button>
        }
    ];

    cancelModal = () => {
        this.setState({
            editorVisible: false,
        });
    };

    createData = () => {
        this.setState({
            editorVisible: true,
            editorTitle: "新增资源"
        });
    };

    editData = (text: number): any => {
        this.setState({
            dataId: text,
            editorVisible: true,
            editorTitle: "编辑资源 ID - " + text.toString(),
        });
    }

    deleteConfirm = (text: number): any => {
        message.warning("删除了id" + text.toString());
    }

    render() {
        let userInfo: any = this.state.userInfo;
        console.log('userInfo', userInfo);
        return (
            <div>

                <div className="page-title">
                    <Title level={3}>资源列表</Title>
                </div>

                <Divider />

                <Row gutter={[18, 6]}>
                    <Col><Button type="primary" onClick={this.createData}><PlusOutlined /> 新增资源</Button></Col>
                    <Col><ExtraSearchForm /></Col>
                </Row>

                <Spin tip="Loading..." size="large" spinning={this.state.loading}>
                    <Table

                        columns={this.columns}
                        dataSource={this.state.memberData}
                        pagination={{
                            total: this.state.total,
                            position: ["bottomLeft"],
                        }}
                        scroll={{
                            x: 1000
                        }}
                    />
                </Spin>
                <ExtraEdit dataId={this.state.dataId} editorVisible={this.state.editorVisible} editorTitle={this.state.editorTitle} onCancel={this.cancelModal} ref="child" />
            </div>
        );
    }
}

export default ExtraList;